import { render } from "./TitleOnlyText.vue?vue&type=template&id=37b1f2ee&scoped=true"
import script from "./TitleOnlyText.vue?vue&type=script&lang=js"
export * from "./TitleOnlyText.vue?vue&type=script&lang=js"

import "./TitleOnlyText.vue?vue&type=style&index=0&id=37b1f2ee&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b1f2ee"]])

export default __exports__